import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sumTotalTickets' })
export class SumTotalTicketsPipe implements PipeTransform {
  transform(operators: any): number {
    if (!operators) {
      return 0;
    }
    return <number>(
      Object.values(operators).reduce(
        (sum: number, operator: any) => sum + (operator.total_tickets || 0),
        0
      )
    );
  }
}
